import { Icon } from '@aqarmap/aqarmap-ui';
import { useTranslation } from 'react-i18next';
import { Link, useLocation, useParams } from 'react-router-dom';
import DescriptionHelpers from '~addListing/pages/ListingDescription/DescriptionHelpers';
import { addListingStepsData } from '~addListing/utils/data';
import ListingMediaHelper from '~addListing/pages/ListingMediaStep/ListingMediaHelper';
import { RoutesEnum } from '~/constants/enums';
import { PREFIX_ROUTE } from '~/constants';

const Steps = () => {
  const pathName = useLocation().pathname;
  const { t } = useTranslation('app');
  const { locale, id } = useParams();
  const listingDescriptionStep = pathName.split('/').includes(RoutesEnum.EDIT);
  const listingMediaStep = pathName.split('/').includes(RoutesEnum.PHOTOS);

  const getActiveStep = () => {
    return {
      step: addListingStepsData.find((step) =>
        pathName.includes(`${step.url}`),
      ),
    };
  };

  return (
    <div className="sticky top-[32px] flex flex-col gap-3x">
      <div className="w-[266px] bg-gray_light_1 rounded-[12px] py-5x px-4x">
        <ul className="flex flex-col gap-4x">
          {addListingStepsData.map((step, index) => {
            const activeStep = getActiveStep();
            return (activeStep.step?.id ?? 0) > step.id && index !== 0 ? (
              <li key={index}>
                <Link
                  to={`/${locale}/${PREFIX_ROUTE}/${RoutesEnum.MY_LISTING}/${id}${step.url}`}
                  className="flex items-center gap-2x relative"
                >
                  <span
                    className={`${activeStep.step?.id === step.id ? 'bg-blue_light_1 border-blue_light_1' : (activeStep?.step?.id ?? 0) > step.id ? 'bg-blue border-blue' : 'border-gray bg-white'} w-[24px] h-[24px] border rounded-full  flex items-center justify-center`}
                  >
                    {(activeStep.step?.id ?? 0) >= step.id && (
                      <Icon name="check" size="16px" className="text-white" />
                    )}
                  </span>
                  <span
                    className={`!h-[24px] ${(activeStep.step?.id ?? 0) > step.id ? 'text-blue' : 'text-gray__dark_2'} text-body_1 `}
                  >
                    {t(step.title)}
                  </span>
                  {index !== addListingStepsData.length - 1 && (
                    <span
                      className={`absolute w-[2px] h-[32px] top-full start-[10px] ${(activeStep?.step?.id ?? 0) > step.id ? 'bg-blue' : 'bg-gray'}`}
                    ></span>
                  )}
                </Link>
              </li>
            ) : (
              <li key={index} className="flex items-center gap-2x relative">
                <span
                  className={`${activeStep.step?.id === step.id ? 'bg-blue_light_1 border-blue_light_1' : (activeStep?.step?.id ?? 0) > step.id ? 'bg-blue border-blue' : 'border-gray bg-white'} w-[24px] h-[24px] border rounded-full  flex items-center justify-center`}
                >
                  {(activeStep.step?.id ?? 0) >= step.id && (
                    <Icon name="check" size="16px" className="text-white" />
                  )}
                </span>
                <span
                  className={`!h-[24px] ${(activeStep.step?.id ?? 0) > step.id ? 'text-blue' : 'text-gray__dark_2'} text-body_1 `}
                >
                  {t(step.title)}
                </span>
                {index !== addListingStepsData.length - 1 && (
                  <span
                    className={`absolute w-[2px] h-[32px] top-full start-[10px] ${(activeStep?.step?.id ?? 0) > step.id ? 'bg-blue' : 'bg-gray'}`}
                  ></span>
                )}
              </li>
            );
          })}
        </ul>
      </div>
      {listingDescriptionStep && (
        <DescriptionHelpers className="hidden md:block" />
      )}
      {listingMediaStep && <ListingMediaHelper className="hidden md:block" />}
    </div>
  );
};

export default Steps;
